<template>
    <Menu>
        <Float :offset="4" :flip="true" placement="bottom-end">
            <MenuButton 
                :class="buttonClass || 'text-gray-600 hover:text-gray-800 border rounded-md border-gray-300 shadow-md px-2 z-10 focus:outline-none'"
                @click.stop>
                <template v-if="menuSvg">
                    <img :src="`/assets/${menuSvg}.svg`" class="w-4 h-6" alt="menu">
                </template>
                <i v-else :class="menuIcon"></i>
            </MenuButton>
            <transition
                 enter-active-class="transition duration-200 ease-out"
                 enter-from-class="transform scale-95 opacity-0"
                 enter-to-class="transform scale-100 opacity-100"
                 leave-active-class="transition duration-200 ease-out"
                 leave-from-class="transform scale-100 opacity-100"
                 leave-to-class="transform scale-95 opacity-0"
            >
                <MenuItems class="bg-white rounded-md shadow-lg border max-h-[60vh] overflow-y-auto focus:outline-none">
                    <MenuItem v-for="(action, index) in actions" 
                            :key="index">
                        <button :class="[
                            action.textColor ? action.textColor : 'text-gray-600',
                            'relative select-none py-2 pl-3 pr-9 text-sm',
                            index < actions.length - 1 ? 'border-b border-gray-200' : ''
                        ]"
                        @click="action.onClick">
                            <div class="flex items-center px-2 py-1">
                                <i :class="['mr-2', action.icon]"></i>
                                <span>{{ action.label }}</span>
                            </div>
                        </button>
                    </MenuItem>
                </MenuItems>
            </transition>
        </Float>
    </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'


export default {
  name: 'EllipsisMenu',
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    Float
  },
  props: {
    actions: {
      type: Array,
      required: true,
      // Each action should have: { label: string, textColor: string, icon: string, onClick: function }
    },
    menuIcon: {
      type: String,
      required: false,
      default: 'fas fa-ellipsis-h'
    },
    menuSvg: {
      type: String,
      required: false,
      default: ''
    },
    buttonClass: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script> 